/**
 * PatientReportSection — "דוחות מטופלים" tab on the unified Reports page.
 *
 * Standalone section (no monthly-report doc dependency): hosts the
 * patient-report generation wizard plus a compact history of previously
 * generated PDFs. The section registry marks it `standalone: true`, so the
 * page renders it without the shared month nav / report gating.
 *
 * History rows of the AI treatments summary open the dedicated AI summary
 * page (patient page › טיפולים) for editing + re-export.
 */

import PatientReportWizard from "./patientReports/PatientReportWizard";
import GeneratedReportsHistory from "./patientReports/GeneratedReportsHistory";
import "./patientReports/PatientReportWizard.css";
import "./patientReports/FinanceReportExport.css";
import "./PatientReportSection.css";

const PatientReportSection = ({
  clinicId,
  scopeTherapistId,
  canExportData,
  canAccessFinance,
}) => {
  const financeAllowed =
    canAccessFinance !== false && canAccessFinance !== null;
  const exportAllowed = canExportData !== false && canExportData !== null;

  return (
    <div className="prs-section">
      <PatientReportWizard
        clinicId={clinicId}
        scopeTherapistId={scopeTherapistId}
        canAccessFinance={financeAllowed}
        canExportData={canExportData}
      />
      <GeneratedReportsHistory
        clinicId={clinicId}
        scopeTherapistId={scopeTherapistId}
        canEdit={exportAllowed}
      />
    </div>
  );
};

export default PatientReportSection;
